import {
  Box,
  Button,
  Checkbox,
  ComboboxItem,
  Fieldset,
  Grid,
  Group,
  LoadingOverlay,
  Select,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconWindow } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { repositoryDelivery } from "../../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { getValueById } from "../../../../_base/helper/FunctionHelper";
import { sky_blue } from "../../../../const/variables";
import { MessageResponse } from "../../../../model/MessageResponse";
import { TblDmMasterOrg } from "../../../../model/TblDMBranch";
import {
  getCommuneSelect,
  getCommuneSelectNew,
  getDistrictSelect,
  getProvinceSelect,
  getProvinceSelectNew,
} from "../../../../service/getSelectApi";

const EditDataView = ({ id, onClose }: EditDataViewProps) => {
  const entity = {
    id: 0,
    code: null,
    name: null,
    address: null,
    phone: null,
    fax: null,
    email: null,
    note: null,
    location: null,
    road: null,
    province: null,
    country: null,
    channelcode: null,
    isonline: null,
    masterInventoryOrg: null,
    guarantee: null,
    orgId: null,
    townName: null,
    provinceId: null,
    companyCode: null,
    attribute1: null,
    attribute2: null,
    attribute3: null,
    attribute4: null,
    attribute5: null,
    attribute6: null,
    attribute7: null,
    attribute8: null,
    attribute9: null,
    attribute10: null,
    attribute11: null,
  };

  const [loadingButton, setLoadingButton] = useState<boolean>(false);
  // theo dõi công ty đang chọn để bật/tắt dấu * của mã Asia
  const [companyCodeSelected, setCompanyCodeSelected] = useState<
    string | null
  >(null);
  const [visible, { toggle, close, open }] = useDisclosure(false);

  const [dataNameAddressNew, setDataNameAddressNew] = useState<any>({
    provinceName: "",
    communeName: "",
    addrName: "",
  });
  const [dataProvinceSelectNew, setDataProvinceSelectNew] = useState<
    ComboboxItem[]
  >([]);
  const [dataCommuneSelectNew, setDataCommuneSelectNew] = useState<
    ComboboxItem[]
  >([]);

  const form = useForm<TblDmMasterOrg>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },

    validate: {
      code: (value: string | null | undefined) => {
        if (!value || value.length === 0) {
          return "Vui lòng nhập mã chi nhánh !";
        }
      },

      name: (value: string | null | undefined) => {
        if (!value || value.length === 0) {
          return "Vui lòng nhập tên chi nhánh !";
        }
      },

      attribute1: (value: string | null | undefined) => {
        if (!value || value.length < 8) {
          return "Số điện thoại không đúng định dạng !";
        }
      },

      channelcode: (value: string | null | undefined, values: any) => {
        // chi nhánh thuộc công ty DVT bắt buộc phải có mã bên ERP Asia
        if (
          values?.companyCode === "DVT" &&
          (!value || value.trim().length === 0)
        ) {
          return "Chi nhánh thuộc công ty DVT phải nhập mã chi nhánh Asia !";
        }
        if (value && value.length > 250) {
          return "Mã chi nhánh Asia không được lớn hơn 250 ký tự !";
        }
      },

      companyCode: (value: string | null | undefined) => {
        if (!value || value.length === 0) {
          return "Vui lòng chọn công ty";
        }
      },

      // attribute4: (value: string | null | undefined) => {
      //   if (!value || value.length === 0) {
      //     return "Vui lòng chọn tỉnh/TP !";
      //   }
      // },

      // attribute5: (value: string | null | undefined) => {
      //   if (!value || value.length === 0) {
      //     return "Vui lòng chọn quận/huyện !";
      //   }
      // },

      // attribute6: (value: string | null | undefined) => {
      //   if (!value || value.length === 0) {
      //     return "Vui lòng chọn phường/xã !";
      //   }
      // },

      attribute8: (value: string | null | undefined) => {
        if (!value || value.length === 0) {
          return "Vui lòng chọn tỉnh/TP !";
        }
      },

      attribute9: (value: string | null | undefined) => {
        if (!value || value.length === 0) {
          return "Vui lòng chọn phường/xã !";
        }
      },
    },
  });

  const getUpdate = async () => {
    const res = await repositoryDelivery.get<MessageResponse<any>>(
      `/api/v1/TblDmMasterOrg/update?id=${id}`
    );

    if (res && res.success) {
      const result = res.data;
      form.setValues(result);
      setCompanyCodeSelected(result?.companyCode ?? null);
      Promise.all([
        fetchDataProvinceNew(true),
        fetchDataCommuneNew(result.attribute8, true),
      ]);

      setDataNameAddressNew((prev: any) => ({
        ...prev,
        provinceName: result.attribute8
          ? getValueById(
              String(result.attribute8),
              dataProvinceSelectNew,
              "label"
            )
          : "",
        addrName: result.attribute10 ? result.attribute10 : "",
      }));
    } else {
      NotificationExtension.Fails(res?.message);
      setLoadingButton(true);
    }
  };

  const fetchDataProvinceNew = async (callFirst: boolean) => {
    const res = await getProvinceSelectNew();

    if (res) {
      const data = res
        ?.filter((item) => item.id && item.name)
        ?.map((item) => ({
          value: String(item.id),
          label: String(item.name),
        }));

      setDataProvinceSelectNew(data);

      if (callFirst) {
        setDataNameAddressNew((prev: any) => ({
          ...prev,
          provinceName: getValueById(
            String(form.getValues()?.attribute8),
            data,
            "label"
          ),
        }));
      }
    }
  };

  const fetchDataCommuneNew = async (id: string, callFirst?: boolean) => {
    const res = await getCommuneSelectNew(id);

    if (res) {
      const data = res
        ?.filter((item) => item.text && item.value)
        ?.map((item) => ({
          value: String(item.value),
          label: String(item.text),
        }));

      setDataCommuneSelectNew(data);

      if (callFirst) {
        setDataNameAddressNew((prev: any) => ({
          ...prev,
          communeName: getValueById(
            String(form.getValues()?.attribute9),
            data,
            "label"
          ),
        }));
      }
    }
  };

  const handleUpdateTblDebtGroup = async (dataSubmit: TblDmMasterOrg) => {
    open();

    const dataApi = await repositoryDelivery.post<MessageResponse<any>>(
      "/api/v1/TblDMMasterOrg/update",
      {
        ...dataSubmit,
        address: [
          dataNameAddressNew.addrName,
          dataNameAddressNew.communeName,
          dataNameAddressNew.provinceName,
        ]
          .filter((i) => i && i.length > 0)
          .join(" - "),
        attribute3: [
          dataNameAddressNew.addrName,
          dataNameAddressNew.communeName,
          dataNameAddressNew.provinceName,
        ]
          .filter((i) => i && i.length > 0)
          .join(" - "),
        attribute10:
          dataNameAddressNew.addrName.length > 0
            ? dataNameAddressNew.addrName
            : null,
      }
    );
    if (dataApi?.success) {
      setTimeout(() => {
        onClose((prev: any) => !prev);
        modals.closeAll();
      }, 1000);

      NotificationExtension.Success("Chỉnh sửa chi nhánh thành công !");
    }
    close();
  };

  useEffect(() => {
    getUpdate();
  }, []);

  return (
    <>
      <Box
        component="form"
        mx="auto"
        onSubmit={form.onSubmit((e: TblDmMasterOrg) => {
          handleUpdateTblDebtGroup(e);
        })}
        style={{ position: "relative" }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Grid mt={10}>
          <Grid.Col span={{ base: 12, md: 4 }}>
            <TextInput
              label="Mã chi nhánh"
              placeholder="Nhập mã chi nhánh"
              readOnly
              variant="filled"
              key={form.key("code")}
              {...form.getInputProps("code")}
              withAsterisk
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 4 }}>
            <TextInput
              label="Mã chi nhánh Asia"
              placeholder="Nhập mã chi nhánh bên ERP Asia"
              key={form.key("channelcode")}
              {...form.getInputProps("channelcode")}
              withAsterisk={companyCodeSelected === "DVT"}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 4 }}>
            <TextInput
              label="Tên chi nhánh"
              placeholder="Nhập tên chi nhánh"
              readOnly
              variant="filled"
              key={form.key("name")}
              {...form.getInputProps("name")}
              withAsterisk
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 4 }}>
            <Select
              label="Công ty"
              placeholder="Chọn công ty"
              data={[
                { label: "HACOM", value: "HACOM" },
                { label: "DVT", value: "DVT" },
              ]}
              key={form.key("companyCode")}
              {...form.getInputProps("companyCode")}
              onChange={(value) => {
                form.setFieldValue("companyCode", value ?? "");
                setCompanyCodeSelected(value);
                form.validateField("channelcode");
              }}
              withAsterisk
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 4 }}>
            <Checkbox
              mt={"xl"}
              key={form.key("isonline")}
              label="Đang sử dụng"
              description="Bỏ tích để dừng sử dụng chi nhánh"
              defaultChecked={Number(form.getValues().isonline) === 1}
              onChange={(e) =>
                form.setFieldValue("isonline", e.currentTarget.checked ? 1 : 0)
              }
            />
          </Grid.Col>
        </Grid>
        <Grid>
          <Grid.Col span={{ base: 12, md: 4 }}>
            <TextInput
              key={form.key("phone")}
              label="SĐT chi nhánh"
              placeholder="Nhập SĐT chi nhánh"
              {...form.getInputProps("phone")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 4 }}>
            <TextInput
              label="SĐT bảo hành"
              placeholder="Nhập SĐT bảo hành"
              key={form.key("attribute1")}
              {...form.getInputProps("attribute1")}
              withAsterisk
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 4 }}>
            <TextInput
              key={form.key("attribute11")}
              label="SĐT chi nhánh dùng cho GV"
              placeholder="Nhập SĐT chi nhánh dùng cho GV"
              type="number"
              {...form.getInputProps("attribute11")}
            />
          </Grid.Col>
        </Grid>
        {/* <Fieldset legend="Địa chỉ chi nhánh (Trước khi sáp nhập tỉnh)">
          <Grid>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Select
                label="Tỉnh/TP"
                placeholder="Chọn tỉnh/thành phố"
                withAsterisk
                data={dataProvinceSelect}
                value={form.getValues()?.attribute4}
                key={form.key("attribute4")}
                {...form.getInputProps("attribute4")}
                onChange={(e) => {
                  if (e) {
                    fetchDataDistrict(String(e));
                    form.setFieldValue("attribute4", e);
                    form.setFieldValue("attribute5", null);
                    form.setFieldValue("attribute6", null);
                    setDataNameAddress((prev: any) => ({
                      ...prev,
                      provinceName: getValueById(
                        String(e),
                        dataProvinceSelect,
                        "label"
                      ),
                      districtName: "",
                      communeName: "",
                    }));
                  } else {
                    setDataNameAddress((prev: any) => ({
                      ...prev,
                      provinceName: "",
                      districtName: "",
                      communeName: "",
                    }));
                    form.setFieldValue("attribute4", null);
                    form.setFieldValue("attribute5", null);
                    form.setFieldValue("attribute6", null);
                  }
                }}
                clearable
                searchable
                nothingFoundMessage="Không tìm thấy dữ liệu !"
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Select
                label="Quận/huyện"
                placeholder="Chọn quận/huyện"
                withAsterisk
                data={dataDistrictSelect}
                value={form.getValues()?.attribute5}
                {...form.getInputProps("attribute5")}
                disabled={dataNameAddress.provinceName.length === 0}
                onChange={(e) => {
                  if (e) {
                    fetchDataCommune(String(e));
                    form.setFieldValue("attribute5", e);
                    form.setFieldValue("attribute6", null);
                    setDataNameAddress((prev: any) => ({
                      ...prev,
                      districtName: getValueById(
                        String(e),
                        dataDistrictSelect,
                        "label"
                      ),
                      communeName: "",
                    }));
                  } else {
                    form.setFieldValue("attribute5", null);
                    form.setFieldValue("attribute6", null);
                    setDataNameAddress((prev: any) => ({
                      ...prev,
                      districtName: "",
                      communeName: "",
                    }));
                  }
                }}
                clearable
                searchable
                nothingFoundMessage="Không tìm thấy dữ liệu !"
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Select
                label="Phường/Xã"
                placeholder="Chọn phường/xã"
                withAsterisk
                data={dataCommuneSelect}
                value={form.getValues()?.attribute6}
                {...form.getInputProps("attribute6")}
                disabled={dataNameAddress?.districtName?.length === 0}
                onChange={(e) => {
                  if (e) {
                    form.setFieldValue("attribute6", e);
                    setDataNameAddress((prev: any) => ({
                      ...prev,
                      communeName: getValueById(
                        String(e),
                        dataCommuneSelect,
                        "label"
                      ),
                    }));
                  } else {
                    form.setFieldValue("attribute6", e);
                    setDataNameAddress((prev: any) => ({
                      ...prev,
                      communeName: "",
                    }));
                  }
                }}
                clearable
                searchable
                nothingFoundMessage="Không tìm thấy dữ liệu !"
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <TextInput
                label="Địa chỉ cụ thể"
                placeholder="Nhập địa chỉ cụ thể"
                key={form.key("attribute7")}
                {...form.getInputProps("attribute7")}
                onChange={(e) =>
                  setDataNameAddress((prev: any) => ({
                    ...prev,
                    addrName: e.currentTarget.value,
                  }))
                }
              />
            </Grid.Col>
          </Grid>
        </Fieldset> */}
        {/* <Fieldset legend="Địa chỉ chi nhánh (Sau khi sáp nhập tỉnh)"> */}
        <Fieldset legend="Địa chỉ chi nhánh">
          <Grid>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Select
                label="Tỉnh/TP"
                placeholder="Chọn tỉnh/thành phố"
                withAsterisk
                data={dataProvinceSelectNew}
                value={form.getValues()?.attribute8}
                key={form.key("attribute8")}
                {...form.getInputProps("attribute8")}
                onChange={(e) => {
                  if (e) {
                    fetchDataCommuneNew(String(e));
                    form.setFieldValue("attribute8", e);
                    form.setFieldValue("attribute9", null);
                    setDataNameAddressNew((prev: any) => ({
                      ...prev,
                      provinceName: getValueById(
                        String(e),
                        dataProvinceSelectNew,
                        "label"
                      ),
                      communeName: "",
                    }));
                  } else {
                    setDataNameAddressNew((prev: any) => ({
                      ...prev,
                      provinceName: "",
                      communeName: "",
                    }));
                    form.setFieldValue("attribute8", null);
                    form.setFieldValue("attribute9", null);
                  }
                }}
                clearable
                searchable
                nothingFoundMessage="Không tìm thấy dữ liệu !"
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Select
                label="Phường/Xã"
                placeholder="Chọn phường/xã"
                withAsterisk
                data={dataCommuneSelectNew}
                value={form.getValues()?.attribute9}
                {...form.getInputProps("attribute9")}
                disabled={dataNameAddressNew?.provinceName.length === 0}
                onChange={(e) => {
                  if (e) {
                    form.setFieldValue("attribute9", e);
                    setDataNameAddressNew((prev: any) => ({
                      ...prev,
                      communeName: getValueById(
                        String(e),
                        dataCommuneSelectNew,
                        "label"
                      ),
                    }));
                  } else {
                    setDataNameAddressNew((prev: any) => ({
                      ...prev,
                      communeName: "",
                    }));
                    form.setFieldValue("attribute9", null);
                  }
                }}
                clearable
                searchable
                nothingFoundMessage="Không tìm thấy dữ liệu !"
              />
            </Grid.Col>
            <Grid.Col span={12}>
              <TextInput
                label="Địa chỉ cụ thể"
                placeholder="Nhập địa chỉ cụ thể"
                key={form.key("attribute10")}
                {...form.getInputProps("attribute10")}
                onChange={(e) =>
                  setDataNameAddressNew((prev: any) => ({
                    ...prev,
                    addrName: e.currentTarget.value,
                  }))
                }
              />
            </Grid.Col>
            <Grid.Col span={12}>
              <TextInput
                label="Số thứ tự hiển thị"
                placeholder="Nhập số thứ tự hiển thị"
                key={form.key("attribute2")}
                {...form.getInputProps("attribute2")}
              />
            </Grid.Col>
          </Grid>
        </Fieldset>

        <Group
          justify="end"
          mt="xs"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="submit"
            color={sky_blue.base}
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
            disabled={loadingButton}
          >
            Lưu
          </Button>
          <></>
        </Group>
      </Box>
    </>
  );
};

export default EditDataView;

type EditDataViewProps = {
  id: string | number;
  onClose: any;
};
